import type { MetadataItem } from '@/graphql/saleor/api';
import { BRAND } from '@/lib/const';
import { getMetaValue } from '@/lib/metadata/helpers';

export const BREITLING_BRAND = 'BREITLING';

/** Pre-multibrand records without `order.brand` are Breitling-only. */
export function resolveOrderBrand(
  orderBrand: string | null | undefined,
): string {
  const normalized = orderBrand?.trim().toUpperCase();
  return normalized || BREITLING_BRAND;
}

export function isForCurrentStorefrontBrand(
  orderBrand: string | null | undefined,
): boolean {
  return resolveOrderBrand(orderBrand) === BRAND.toUpperCase();
}

export function getOrderBrandFromMetadata(
  metadata: readonly MetadataItem[],
): string | null {
  return (
    getMetaValue(metadata, 'order.brand') ||
    getMetaValue(metadata, 'brand') ||
    null
  );
}

export function isOrderForCurrentStorefront(
  metadata: readonly MetadataItem[],
): boolean {
  return isForCurrentStorefrontBrand(getOrderBrandFromMetadata(metadata));
}

export function isCheckoutForCurrentStorefront(
  orderBrand: string | null | undefined,
  brand: string | null | undefined,
): boolean {
  return isForCurrentStorefrontBrand(orderBrand || brand || null);
}
